import { MotiView } from "moti";
import React, { useEffect, useState } from "react";
import { StyleSheet } from "react-native";

import { AnimationDurations } from "../../../theme/animations";
import { Box } from "../../primitive";

type AnimateHeightProps = {
  children?: React.ReactNode;
  hide?: boolean;
  onHeightDidAnimate?: (height: number) => void;
  enterFrom?: "bottom" | "top";
  initialHeight?: number;
} & React.ComponentProps<typeof MotiView>;

export const AnimateHeight = ({
  children,
  hide = false,
}: AnimateHeightProps) => {
  const [targetAnimationValues, setTargetAnimationValues] = useState(
    closedAnimationValues
  );
  const [openHeight, setOpenHeight] = useState(0);

  useEffect(() => {
    if (hide) {
      setTargetAnimationValues(closedAnimationValues);
    } else {
      setTargetAnimationValues({ opacity: 1, height: openHeight });
    }
  }, [hide, openHeight]);
  return (
    <MotiView
      transition={{
        height: { type: "timing", duration: AnimationDurations.moderate01 },
        opacity: { type: "timing", duration: AnimationDurations.moderate01 },
      }}
      animate={targetAnimationValues}
      style={{ overflow: "hidden" }}
    >
      <Box
        style={[StyleSheet.absoluteFill, { bottom: "auto" }]}
        onLayout={({ nativeEvent }) => {
          const height = nativeEvent.layout.height;
          setOpenHeight(height);
        }}
      >
        {children}
      </Box>
    </MotiView>
  );
};

const closedAnimationValues = {
  height: 0,
  opacity: 0,
};
